// extracted by mini-css-extract-plugin
export default {"route":"daFGjN","route--mobile":"mUfLlp","arrow":"nIvgPG","arrow--mobile":"XIKEzw"};